import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const NavLink = ({ to, children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <li
      onClick={() => {
        navigate(to);
      }}
      className={`cursor-pointer relative z-50 px-4 py-4 m-2 text-lg uppercase border-l border-r text-slate-900 lg:border-transparent lg:m-0 lg:border-t lg:border-l-0 lg:border-r-0 hover:border-sky-500 hover:text-sky-500 hover:font-medium ${
        location.pathname === to && "font-medium !text-sky-500 border-sky-500"
      }`}
    >
      {children}
    </li>
  );
};

export default NavLink;
